import { createContext } from 'react';

import { AppBarHeadingContextType } from './types';

export const AppBarHeadingContext = createContext<AppBarHeadingContextType | null>(null);
